import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

// material ui
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

// utils
import { StoreContext } from "../../../../../store/StoreProvider";
import { isEmpty } from "../../../../../utils";
import { Api, readOntoData } from "../../../../../api/land/Api";
import Act from "../../../../../store/actions";
import { basicPlaceHolder } from "../../common/phDes";
import {
  disableEditFunction,
  disableFontColor,
  getColOrder,
  landBasicRule,
  setLNAndLSN,
} from "../../common";
import hisAddSearch from "../../../../../utils/hisAddSearch";

// components
import CustomLoading from "../../../../../Component/CustomLoading/CustomLoading";

function BasicInfo() {
  const history = useHistory();
  const [state, dispatch] = useContext(StoreContext);
  const { edit } = state;
  const { basicInfo, infoLoading, landId, LSNList } = edit;
  const [otherLSNList, setOtherLSNList] = useState([]);

  useEffect(() => {
    if (!landId || isEmpty(LSNList)) {
      setOtherLSNList([]);
      return;
    }
    const tmpList = LSNList.filter((el) => el.landId !== landId);
    setOtherLSNList(tmpList);
  }, [LSNList, landId]);

  useEffect(() => {
    if (isEmpty(landId)) {
      dispatch({
        type: Act.SET_BASICINFO,
        payload: [],
      });
      dispatch({
        type: Act.SET_EXTRABASIC,
        payload: [],
      });
      return;
    }

    const apiStr = Api.getBasicInfoById().replace("{landId}", landId);

    // 打開Info Loading circle
    dispatch({
      type: Act.SET_INFOLOADING,
      payload: true,
    });

    readOntoData(apiStr).then(async (result) => {
      // console.log(result.data);
      if (!isEmpty(result.data)) {
        const tmpId = result.data[0]?.landId || "";
        // URL紀錄landId
        hisAddSearch(history, { landId: tmpId });
        // update landName and landSerialNumber
        setLNAndLSN(result.data, dispatch);
      }

      const tmpInfo = JSON.parse(JSON.stringify(result.data));

      const colOrder = await getColOrder("Basic");
      const { landId: resLandId } = tmpInfo.find((info) => info.landId);

      const tmpBasicInfo = colOrder.map((element) => {
        const findValue = tmpInfo.find(
          (info) => info.predicate === element.property
        );
        if (findValue) {
          return {
            landId: resLandId,
            object: element.label,
            value: findValue.value,
            predicate: findValue.predicate,
          };
        }
        return {
          landId: resLandId,
          object: element.label,
          value: "",
          predicate: element.property,
        };
      });

      dispatch({
        type: Act.SET_BASICINFO,
        payload: tmpBasicInfo,
      });

      // 其他基本資料
      const extraBasicPredicate = [
        { predicate: "collectionPlace", object: "原典藏地" },
        { predicate: "boxNumber", object: "箱號" },
        { predicate: "oldCadastralMapNumber", object: "舊圖號" },
        { predicate: "oldCategory", object: "舊地目" },
        { predicate: "operator", object: "作業者" },
      ];
      const tmpArr = [];
      extraBasicPredicate.forEach((info) => {
        const findObj = tmpInfo.find(
          (element) => element.predicate === info.predicate
        );
        if (findObj) {
          tmpArr.push(findObj);
        } else {
          tmpArr.push({
            landId: resLandId,
            predicate: info.predicate,
            value: "",
            object: info.object,
          });
        }
      });

      dispatch({
        type: Act.SET_EXTRABASIC,
        payload: tmpArr,
      });

      // 檢查編輯狀態，取得編輯者資料
      const findLockUser = result.data.find(
        (element) => element.predicate === "lockUser"
      );
      dispatch({
        type: Act.SET_ISLOCK,
        payload: !!findLockUser,
      });

      dispatch({
        type: Act.SET_LOCKERUSER,
        payload: findLockUser ? findLockUser.value : "",
      });

      // 關閉Info Loading circle
      dispatch({
        type: Act.SET_INFOLOADING,
        payload: false,
      });
    });
  }, [landId]);

  const handleChange = (event, item) => {
    const tmpBasicInfo = JSON.parse(JSON.stringify(basicInfo));
    const findCol = tmpBasicInfo.find(
      (element) => element.predicate === item.predicate
    );
    if (findCol) {
      findCol.value = event.target.value;
      dispatch({
        type: Act.SET_BASICINFO,
        payload: tmpBasicInfo,
      });
    }
  };

  return (
    <Grid item className="BaiscInfo">
      <Grid item container className="BasicItem">
        <Grid item xs={1} className="colName">
          基本資料
        </Grid>
        {infoLoading ? (
          <Grid container>
            <CustomLoading />
          </Grid>
        ) : (
          <Grid item container direction="column" className="BasicinfoArea">
            {basicInfo.map((item, index) => (
              <Grid item container key={index}>
                <Grid item xs={2} className="labelName">
                  {item.object}
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    disabled={disableEditFunction(state)}
                    variant="standard"
                    fullWidth
                    value={item.value}
                    placeholder={basicPlaceHolder[item.predicate]}
                    onChange={(e) => handleChange(e, item)}
                    multiline
                    inputProps={disableFontColor}
                    error={landBasicRule(item, otherLSNList).check}
                    helperText={landBasicRule(item, otherLSNList).helpText}
                  />
                </Grid>
              </Grid>
            ))}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}

export default BasicInfo;
